import React, { FC } from 'react';
import EditGroupForm from '../../../components/forms/groups/EditGroupForm';
import TextHeader from '../../../components/headers/TextHeader';
import Tabs from '../../../components/tabs/Tabs';
import AssetPacksCointainer from '../../assets/AssetPacksContainer';
import GroupMembersContainer from './GroupMembersContainer';

export interface Props {
  data: {
    group: any;
  };
}

const GroupDetailContainer: FC<Props> = ({ data: { group } }) => {
  console.log(group);
  const tabs = [
    {
      nav: 'Bewerken',
      component: [<EditGroupForm group={group} />],
    },
    {
      nav: 'Gebruikers',
      component: [<GroupMembersContainer group={group} />],
    },
    ...(group?.bedGr_id
      ? [
          {
            nav: 'IT Packs',
            component: [
              <AssetPacksCointainer groupId={group.bedGr_id.toString()} />,
            ],
          },
        ]
      : []),
  ];
  return (
    <div>
      <TextHeader title={group.bedGr_naam} subtitle={'Groep'} />
      <Tabs tabs={tabs} />
    </div>
  );
};

export default GroupDetailContainer;
